import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const scrollToTop = (duration = 300, el = null) => {
  const start = el ? el.scrollTop : window.scrollY;
  if (start === 0) return;
  const startTime = performance.now();
  const step = (timestamp) => {
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = 1 - Math.pow(1 - progress, 3);
    const value = start * (1 - ease);
    if (el) {
      el.scrollTop = value;
    } else {
      window.scrollTo(0, value);
    }
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
